// ContinueButton.jsx
// Action button component for continuing the setup process

import React, { useState } from 'react';
import { styles } from './styles';

const ContinueButton = ({ onContinue }) => {
  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    ...styles.button,
    ...(isHovered ? styles.buttonHover : {})
  };

  return (
    <button 
      onClick={onContinue}
      style={buttonStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span style={styles.buttonIcon}>🚀</span>
      Continue Setup
    </button>
  );
};

export default ContinueButton;